import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AttachmentUploadUrl = {
  __typename: 'AttachmentUploadUrl';
  storagePath: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CheckoutReminderOptions = {
  __typename: 'CheckoutReminderOptions';
  checkoutInstructions: Scalars['String']['output'];
  checkoutInstructionsVersion: Scalars['String']['output'];
  disclosure: Scalars['String']['output'];
  disclosureVersion: Scalars['String']['output'];
  emailAvailable: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  privacyUrl: Scalars['String']['output'];
  smsAvailable: Scalars['Boolean']['output'];
  termsUrl: Scalars['String']['output'];
};

export type CheckoutReminderPreferenceInput = {
  assignmentId: Scalars['ID']['input'];
  dismissPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  smsDisclosureVersion?: InputMaybe<Scalars['String']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};

export type CheckoutReminderPreferences = {
  __typename: 'CheckoutReminderPreferences';
  emailBlockedReason?: Maybe<Scalars['String']['output']>;
  emailEnabled: Scalars['Boolean']['output'];
  guestId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  promptDismissed: Scalars['Boolean']['output'];
  smsBlockedReason?: Maybe<Scalars['String']['output']>;
  smsConsentScope?: Maybe<Scalars['String']['output']>;
  smsEnabled: Scalars['Boolean']['output'];
};

export type ConfirmWorkOrderRequestAttachmentInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  storagePath: Scalars['String']['input'];
  uploadToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkOrderRequestInput = {
  assignmentId?: InputMaybe<Scalars['ID']['input']>;
  basecampId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  description: Scalars['String']['input'];
  location: Scalars['String']['input'];
  priority: WorkOrderPriority;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type EntityAttachment = {
  __typename: 'EntityAttachment';
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  signedUrl?: Maybe<Scalars['String']['output']>;
  storagePath: Scalars['String']['output'];
};

export type EvaluatedFeatureFlag = {
  __typename: 'EvaluatedFeatureFlag';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type FeatureFlags = {
  __typename: 'FeatureFlags';
  flags: Array<EvaluatedFeatureFlag>;
  revision: Scalars['String']['output'];
};

export type GenerateWorkOrderRequestAttachmentUploadUrlInput = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  uploadToken?: InputMaybe<Scalars['String']['input']>;
};

export type IssueReportBasecamp = {
  __typename: 'IssueReportBasecamp';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  confirmWorkOrderRequestAttachment: EntityAttachment;
  createWorkOrderRequest: WorkOrderRequest;
  endSelfCheckinSession: Scalars['Boolean']['output'];
  generateWorkOrderRequestAttachmentUploadUrl: AttachmentUploadUrl;
  resendBasecampEmailVerification: Scalars['Boolean']['output'];
  selfCheckOut: SelfCheckOutResult;
  selfCheckin: SelfCheckinResult;
  updateBasecampEmail: Scalars['Boolean']['output'];
  updateCheckoutReminderPreferences: CheckoutReminderPreferences;
  verifyBasecampEmail: VerifyBasecampEmailResult;
};


export type MutationConfirmWorkOrderRequestAttachmentArgs = {
  input: ConfirmWorkOrderRequestAttachmentInput;
};


export type MutationCreateWorkOrderRequestArgs = {
  input: CreateWorkOrderRequestInput;
};


export type MutationEndSelfCheckinSessionArgs = {
  token: Scalars['String']['input'];
};


export type MutationGenerateWorkOrderRequestAttachmentUploadUrlArgs = {
  input: GenerateWorkOrderRequestAttachmentUploadUrlInput;
};


export type MutationResendBasecampEmailVerificationArgs = {
  token: Scalars['String']['input'];
};


export type MutationSelfCheckOutArgs = {
  assignmentId: Scalars['ID']['input'];
  missingItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  source?: InputMaybe<SelfCheckinLifecycleSource>;
  token: Scalars['String']['input'];
};


export type MutationSelfCheckinArgs = {
  input: SelfCheckinInput;
};


export type MutationUpdateBasecampEmailArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateCheckoutReminderPreferencesArgs = {
  input: CheckoutReminderPreferenceInput;
};


export type MutationVerifyBasecampEmailArgs = {
  verificationToken: Scalars['String']['input'];
};

export type Query = {
  __typename: 'Query';
  checkoutReminderOptions: CheckoutReminderOptions;
  checkoutReminderPreferences: CheckoutReminderPreferences;
  featureFlags: FeatureFlags;
  issueReportBasecamps: Array<IssueReportBasecamp>;
  selfCheckOutChecklist: Array<SelfCheckOutChecklistItem>;
  selfCheckinLookup: SelfCheckinLookupResult;
  selfCheckinReservation: SelfCheckinReservation;
  selfCheckinSession: SelfCheckinLookupResult;
};


export type QueryCheckoutReminderPreferencesArgs = {
  assignmentId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type QueryFeatureFlagsArgs = {
  basecampId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySelfCheckOutChecklistArgs = {
  assignmentId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type QuerySelfCheckinLookupArgs = {
  edipi?: InputMaybe<Scalars['String']['input']>;
  identity?: InputMaybe<SelfCheckinIdentityInput>;
};


export type QuerySelfCheckinReservationArgs = {
  assignmentId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type QuerySelfCheckinSessionArgs = {
  token: Scalars['String']['input'];
};

export type SelfCheckOutChecklistItem = {
  __typename: 'SelfCheckOutChecklistItem';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type SelfCheckOutResult = {
  __typename: 'SelfCheckOutResult';
  checkedOutAt: Scalars['String']['output'];
  message: Scalars['String']['output'];
  roomNumber: Scalars['String']['output'];
};

export type SelfCheckinFacilityCode = {
  __typename: 'SelfCheckinFacilityCode';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type SelfCheckinIdentityInput = {
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  edipi?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  type: SelfCheckinIdentityType;
};

export enum SelfCheckinIdentityType {
  CivilianNameDate = 'CIVILIAN_NAME_DATE',
  DodId = 'DOD_ID'
}

export type SelfCheckinInput = {
  acknowledgedCheckoutDate?: InputMaybe<Scalars['String']['input']>;
  assignmentId: Scalars['ID']['input'];
  carMake?: InputMaybe<Scalars['String']['input']>;
  carPlateNumber?: InputMaybe<Scalars['String']['input']>;
  checkoutAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutInstructionsVersion?: InputMaybe<Scalars['String']['input']>;
  edipi?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  identity?: InputMaybe<SelfCheckinIdentityInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  smsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  smsDisclosureVersion?: InputMaybe<Scalars['String']['input']>;
  smsPromptDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<SelfCheckinLifecycleSource>;
};

export enum SelfCheckinLifecycleSource {
  GuestDevice = 'GUEST_DEVICE',
  Kiosk = 'KIOSK'
}

export type SelfCheckinLookupReservation = {
  __typename: 'SelfCheckinLookupReservation';
  assignmentId: Scalars['ID']['output'];
  basecampId: Scalars['ID']['output'];
  basecampName: Scalars['String']['output'];
  checkInDate: Scalars['String']['output'];
  checkOutDate?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['String']['output']>;
  guestFirstName: Scalars['String']['output'];
  guestLastName: Scalars['String']['output'];
  guestPhone?: Maybe<Scalars['String']['output']>;
  hasEmail: Scalars['Boolean']['output'];
  hasVehicle: Scalars['Boolean']['output'];
  smsReminderStatus?: Maybe<Scalars['String']['output']>;
};

export type SelfCheckinLookupResult = {
  __typename: 'SelfCheckinLookupResult';
  reservations: Array<SelfCheckinLookupReservation>;
};

export type SelfCheckinReservation = {
  __typename: 'SelfCheckinReservation';
  buildingAccessCode?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  buildings: Array<SelfCheckinReservationBuilding>;
  checkInDate: Scalars['String']['output'];
  checkOutDate?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['String']['output']>;
  checkedOutAt?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  facilityCodes: Array<SelfCheckinFacilityCode>;
  guestEmail?: Maybe<Scalars['String']['output']>;
  guestFirstName: Scalars['String']['output'];
  guestLastName: Scalars['String']['output'];
  mapImageUrl?: Maybe<Scalars['String']['output']>;
  roomAccessCode?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['Int']['output'];
  roomNumber: Scalars['String']['output'];
  token: Scalars['String']['output'];
  welcomePamphletFilename?: Maybe<Scalars['String']['output']>;
  welcomePamphletUrl?: Maybe<Scalars['String']['output']>;
};

export type SelfCheckinReservationBuilding = {
  __typename: 'SelfCheckinReservationBuilding';
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

export type SelfCheckinResult = {
  __typename: 'SelfCheckinResult';
  buildingAccessCode?: Maybe<Scalars['String']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  checkInDate: Scalars['String']['output'];
  checkOutDate?: Maybe<Scalars['String']['output']>;
  guestFirstName: Scalars['String']['output'];
  guestLastName: Scalars['String']['output'];
  roomAccessCode?: Maybe<Scalars['String']['output']>;
  roomNumber: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type VerifyBasecampEmailResult = {
  __typename: 'VerifyBasecampEmailResult';
  guestFirstName?: Maybe<Scalars['String']['output']>;
  status: VerifyBasecampEmailStatus;
};

export enum VerifyBasecampEmailStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Verified = 'VERIFIED'
}

export enum WorkOrderPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export type WorkOrderRequest = {
  __typename: 'WorkOrderRequest';
  contactEmail: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  priority: WorkOrderPriority;
  uploadToken: Scalars['String']['output'];
};

export type ConfirmWorkOrderRequestAttachmentMutationVariables = Exact<{
  input: ConfirmWorkOrderRequestAttachmentInput;
}>;


export type ConfirmWorkOrderRequestAttachmentMutation = { __typename: 'Mutation', confirmWorkOrderRequestAttachment: { __typename: 'EntityAttachment', id: string, fileName: string } };

export type CreateWorkOrderRequestMutationVariables = Exact<{
  input: CreateWorkOrderRequestInput;
}>;


export type CreateWorkOrderRequestMutation = { __typename: 'Mutation', createWorkOrderRequest: { __typename: 'WorkOrderRequest', id: string, uploadToken: string, createdAt: string } };

export type EndSelfCheckinSessionMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type EndSelfCheckinSessionMutation = { __typename: 'Mutation', endSelfCheckinSession: boolean };

export type FeatureFlagsQueryVariables = Exact<{
  basecampId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeatureFlagsQuery = { __typename: 'Query', featureFlags: { __typename: 'FeatureFlags', revision: string, flags: Array<{ __typename: 'EvaluatedFeatureFlag', key: string, enabled: boolean }> } };

export type GenerateWorkOrderRequestAttachmentUploadUrlMutationVariables = Exact<{
  input: GenerateWorkOrderRequestAttachmentUploadUrlInput;
}>;


export type GenerateWorkOrderRequestAttachmentUploadUrlMutation = { __typename: 'Mutation', generateWorkOrderRequestAttachmentUploadUrl: { __typename: 'AttachmentUploadUrl', url: string, storagePath: string } };

export type GetIssueReportBasecampsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIssueReportBasecampsQuery = { __typename: 'Query', issueReportBasecamps: Array<{ __typename: 'IssueReportBasecamp', id: string, name: string }> };

export type ResendBasecampEmailVerificationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ResendBasecampEmailVerificationMutation = { __typename: 'Mutation', resendBasecampEmailVerification: boolean };

export type SelfCheckOutMutationVariables = Exact<{
  token: Scalars['String']['input'];
  assignmentId: Scalars['ID']['input'];
  missingItemIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  source?: InputMaybe<SelfCheckinLifecycleSource>;
}>;


export type SelfCheckOutMutation = { __typename: 'Mutation', selfCheckOut: { __typename: 'SelfCheckOutResult', message: string, roomNumber: string, checkedOutAt: string } };

export type GetSelfCheckOutChecklistQueryVariables = Exact<{
  token: Scalars['String']['input'];
  assignmentId: Scalars['ID']['input'];
}>;


export type GetSelfCheckOutChecklistQuery = { __typename: 'Query', selfCheckOutChecklist: Array<{ __typename: 'SelfCheckOutChecklistItem', id: number, label: string, sortOrder: number }> };

export type SelfCheckinMutationVariables = Exact<{
  input: SelfCheckinInput;
}>;


export type SelfCheckinMutation = { __typename: 'Mutation', selfCheckin: { __typename: 'SelfCheckinResult', token: string, guestFirstName: string, guestLastName: string, roomNumber: string, buildingName?: string | null, buildingAccessCode?: string | null, roomAccessCode?: string | null, checkInDate: string, checkOutDate?: string | null } };

export type GetSelfCheckinLookupQueryVariables = Exact<{
  identity: SelfCheckinIdentityInput;
}>;


export type GetSelfCheckinLookupQuery = { __typename: 'Query', selfCheckinLookup: { __typename: 'SelfCheckinLookupResult', reservations: Array<{ __typename: 'SelfCheckinLookupReservation', assignmentId: string, basecampId: string, basecampName: string, guestFirstName: string, guestLastName: string, checkInDate: string, checkOutDate?: string | null, checkedInAt?: string | null, smsReminderStatus?: string | null, guestPhone?: string | null, hasEmail: boolean, hasVehicle: boolean }> } };

export type GetSelfCheckinReservationQueryVariables = Exact<{
  token: Scalars['String']['input'];
  assignmentId: Scalars['ID']['input'];
}>;


export type GetSelfCheckinReservationQuery = { __typename: 'Query', selfCheckinReservation: { __typename: 'SelfCheckinReservation', token: string, guestFirstName: string, guestLastName: string, roomNumber: string, roomId: number, buildingId?: number | null, buildingName?: string | null, buildingAccessCode?: string | null, roomAccessCode?: string | null, checkInDate: string, checkOutDate?: string | null, checkedInAt?: string | null, checkedOutAt?: string | null, mapImageUrl?: string | null, welcomePamphletUrl?: string | null, welcomePamphletFilename?: string | null, guestEmail?: string | null, emailVerified: boolean, buildings: Array<{ __typename: 'SelfCheckinReservationBuilding', id: number, name: string, positionX?: number | null, positionY?: number | null, gender?: string | null }>, facilityCodes: Array<{ __typename: 'SelfCheckinFacilityCode', id: string, label: string, code: string }> } };

export type GetSelfCheckinSessionQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetSelfCheckinSessionQuery = { __typename: 'Query', selfCheckinSession: { __typename: 'SelfCheckinLookupResult', reservations: Array<{ __typename: 'SelfCheckinLookupReservation', assignmentId: string, basecampId: string, basecampName: string, guestFirstName: string, guestLastName: string, checkInDate: string, checkOutDate?: string | null, checkedInAt?: string | null, guestPhone?: string | null, hasEmail: boolean, hasVehicle: boolean }> } };

export type UpdateBasecampEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateBasecampEmailMutation = { __typename: 'Mutation', updateBasecampEmail: boolean };

export type VerifyBasecampEmailMutationVariables = Exact<{
  verificationToken: Scalars['String']['input'];
}>;


export type VerifyBasecampEmailMutation = { __typename: 'Mutation', verifyBasecampEmail: { __typename: 'VerifyBasecampEmailResult', status: VerifyBasecampEmailStatus, guestFirstName?: string | null } };

export type CheckoutReminderOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutReminderOptionsQuery = { __typename: 'Query', checkoutReminderOptions: { __typename: 'CheckoutReminderOptions', enabled: boolean, smsAvailable: boolean, emailAvailable: boolean, disclosureVersion: string, disclosure: string, privacyUrl: string, termsUrl: string } };

export type CheckoutReminderPreferencesQueryVariables = Exact<{
  token: Scalars['String']['input'];
  assignmentId: Scalars['ID']['input'];
}>;


export type CheckoutReminderPreferencesQuery = { __typename: 'Query', checkoutReminderPreferences: { __typename: 'CheckoutReminderPreferences', guestId: string, phone?: string | null, promptDismissed: boolean, smsEnabled: boolean, smsConsentScope?: string | null, emailEnabled: boolean, smsBlockedReason?: string | null, emailBlockedReason?: string | null } };

export type UpdateCheckoutReminderPreferencesMutationVariables = Exact<{
  input: CheckoutReminderPreferenceInput;
}>;


export type UpdateCheckoutReminderPreferencesMutation = { __typename: 'Mutation', updateCheckoutReminderPreferences: { __typename: 'CheckoutReminderPreferences', guestId: string, phone?: string | null, promptDismissed: boolean, smsEnabled: boolean, smsConsentScope?: string | null, emailEnabled: boolean, smsBlockedReason?: string | null, emailBlockedReason?: string | null } };


export const ConfirmWorkOrderRequestAttachmentDocument = gql`
    mutation ConfirmWorkOrderRequestAttachment($input: ConfirmWorkOrderRequestAttachmentInput!) {
  confirmWorkOrderRequestAttachment(input: $input) {
    id
    fileName
  }
}
    `;
export type ConfirmWorkOrderRequestAttachmentMutationFn = Apollo.MutationFunction<ConfirmWorkOrderRequestAttachmentMutation, ConfirmWorkOrderRequestAttachmentMutationVariables>;

/**
 * __useConfirmWorkOrderRequestAttachmentMutation__
 *
 * To run a mutation, you first call `useConfirmWorkOrderRequestAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmWorkOrderRequestAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmWorkOrderRequestAttachmentMutation, { data, loading, error }] = useConfirmWorkOrderRequestAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmWorkOrderRequestAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmWorkOrderRequestAttachmentMutation, ConfirmWorkOrderRequestAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmWorkOrderRequestAttachmentMutation, ConfirmWorkOrderRequestAttachmentMutationVariables>(ConfirmWorkOrderRequestAttachmentDocument, options);
      }
export type ConfirmWorkOrderRequestAttachmentMutationHookResult = ReturnType<typeof useConfirmWorkOrderRequestAttachmentMutation>;
export type ConfirmWorkOrderRequestAttachmentMutationResult = Apollo.MutationResult<ConfirmWorkOrderRequestAttachmentMutation>;
export type ConfirmWorkOrderRequestAttachmentMutationOptions = Apollo.BaseMutationOptions<ConfirmWorkOrderRequestAttachmentMutation, ConfirmWorkOrderRequestAttachmentMutationVariables>;
export const CreateWorkOrderRequestDocument = gql`
    mutation CreateWorkOrderRequest($input: CreateWorkOrderRequestInput!) {
  createWorkOrderRequest(input: $input) {
    id
    uploadToken
    createdAt
  }
}
    `;
export type CreateWorkOrderRequestMutationFn = Apollo.MutationFunction<CreateWorkOrderRequestMutation, CreateWorkOrderRequestMutationVariables>;

/**
 * __useCreateWorkOrderRequestMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderRequestMutation, { data, loading, error }] = useCreateWorkOrderRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkOrderRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWorkOrderRequestMutation, CreateWorkOrderRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkOrderRequestMutation, CreateWorkOrderRequestMutationVariables>(CreateWorkOrderRequestDocument, options);
      }
export type CreateWorkOrderRequestMutationHookResult = ReturnType<typeof useCreateWorkOrderRequestMutation>;
export type CreateWorkOrderRequestMutationResult = Apollo.MutationResult<CreateWorkOrderRequestMutation>;
export type CreateWorkOrderRequestMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderRequestMutation, CreateWorkOrderRequestMutationVariables>;
export const EndSelfCheckinSessionDocument = gql`
    mutation EndSelfCheckinSession($token: String!) {
  endSelfCheckinSession(token: $token)
}
    `;
export type EndSelfCheckinSessionMutationFn = Apollo.MutationFunction<EndSelfCheckinSessionMutation, EndSelfCheckinSessionMutationVariables>;

/**
 * __useEndSelfCheckinSessionMutation__
 *
 * To run a mutation, you first call `useEndSelfCheckinSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndSelfCheckinSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endSelfCheckinSessionMutation, { data, loading, error }] = useEndSelfCheckinSessionMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEndSelfCheckinSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EndSelfCheckinSessionMutation, EndSelfCheckinSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EndSelfCheckinSessionMutation, EndSelfCheckinSessionMutationVariables>(EndSelfCheckinSessionDocument, options);
      }
export type EndSelfCheckinSessionMutationHookResult = ReturnType<typeof useEndSelfCheckinSessionMutation>;
export type EndSelfCheckinSessionMutationResult = Apollo.MutationResult<EndSelfCheckinSessionMutation>;
export type EndSelfCheckinSessionMutationOptions = Apollo.BaseMutationOptions<EndSelfCheckinSessionMutation, EndSelfCheckinSessionMutationVariables>;
export const FeatureFlagsDocument = gql`
    query featureFlags($basecampId: Int) {
  featureFlags(basecampId: $basecampId) {
    revision
    flags {
      key
      enabled
    }
  }
}
    `;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *      basecampId: // value for 'basecampId'
 *   },
 * });
 */
export function useFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
      }
export function useFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export function useFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>;
export type FeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagsSuspenseQuery>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const GenerateWorkOrderRequestAttachmentUploadUrlDocument = gql`
    mutation GenerateWorkOrderRequestAttachmentUploadUrl($input: GenerateWorkOrderRequestAttachmentUploadUrlInput!) {
  generateWorkOrderRequestAttachmentUploadUrl(input: $input) {
    url
    storagePath
  }
}
    `;
export type GenerateWorkOrderRequestAttachmentUploadUrlMutationFn = Apollo.MutationFunction<GenerateWorkOrderRequestAttachmentUploadUrlMutation, GenerateWorkOrderRequestAttachmentUploadUrlMutationVariables>;

/**
 * __useGenerateWorkOrderRequestAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateWorkOrderRequestAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorkOrderRequestAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorkOrderRequestAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateWorkOrderRequestAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateWorkOrderRequestAttachmentUploadUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateWorkOrderRequestAttachmentUploadUrlMutation, GenerateWorkOrderRequestAttachmentUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateWorkOrderRequestAttachmentUploadUrlMutation, GenerateWorkOrderRequestAttachmentUploadUrlMutationVariables>(GenerateWorkOrderRequestAttachmentUploadUrlDocument, options);
      }
export type GenerateWorkOrderRequestAttachmentUploadUrlMutationHookResult = ReturnType<typeof useGenerateWorkOrderRequestAttachmentUploadUrlMutation>;
export type GenerateWorkOrderRequestAttachmentUploadUrlMutationResult = Apollo.MutationResult<GenerateWorkOrderRequestAttachmentUploadUrlMutation>;
export type GenerateWorkOrderRequestAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateWorkOrderRequestAttachmentUploadUrlMutation, GenerateWorkOrderRequestAttachmentUploadUrlMutationVariables>;
export const GetIssueReportBasecampsDocument = gql`
    query GetIssueReportBasecamps {
  issueReportBasecamps {
    id
    name
  }
}
    `;

/**
 * __useGetIssueReportBasecampsQuery__
 *
 * To run a query within a React component, call `useGetIssueReportBasecampsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssueReportBasecampsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssueReportBasecampsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIssueReportBasecampsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIssueReportBasecampsQuery, GetIssueReportBasecampsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIssueReportBasecampsQuery, GetIssueReportBasecampsQueryVariables>(GetIssueReportBasecampsDocument, options);
      }
export function useGetIssueReportBasecampsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIssueReportBasecampsQuery, GetIssueReportBasecampsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIssueReportBasecampsQuery, GetIssueReportBasecampsQueryVariables>(GetIssueReportBasecampsDocument, options);
        }
export function useGetIssueReportBasecampsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIssueReportBasecampsQuery, GetIssueReportBasecampsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIssueReportBasecampsQuery, GetIssueReportBasecampsQueryVariables>(GetIssueReportBasecampsDocument, options);
        }
export type GetIssueReportBasecampsQueryHookResult = ReturnType<typeof useGetIssueReportBasecampsQuery>;
export type GetIssueReportBasecampsLazyQueryHookResult = ReturnType<typeof useGetIssueReportBasecampsLazyQuery>;
export type GetIssueReportBasecampsSuspenseQueryHookResult = ReturnType<typeof useGetIssueReportBasecampsSuspenseQuery>;
export type GetIssueReportBasecampsQueryResult = Apollo.QueryResult<GetIssueReportBasecampsQuery, GetIssueReportBasecampsQueryVariables>;
export const ResendBasecampEmailVerificationDocument = gql`
    mutation ResendBasecampEmailVerification($token: String!) {
  resendBasecampEmailVerification(token: $token)
}
    `;
export type ResendBasecampEmailVerificationMutationFn = Apollo.MutationFunction<ResendBasecampEmailVerificationMutation, ResendBasecampEmailVerificationMutationVariables>;

/**
 * __useResendBasecampEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendBasecampEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBasecampEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBasecampEmailVerificationMutation, { data, loading, error }] = useResendBasecampEmailVerificationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResendBasecampEmailVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendBasecampEmailVerificationMutation, ResendBasecampEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendBasecampEmailVerificationMutation, ResendBasecampEmailVerificationMutationVariables>(ResendBasecampEmailVerificationDocument, options);
      }
export type ResendBasecampEmailVerificationMutationHookResult = ReturnType<typeof useResendBasecampEmailVerificationMutation>;
export type ResendBasecampEmailVerificationMutationResult = Apollo.MutationResult<ResendBasecampEmailVerificationMutation>;
export type ResendBasecampEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ResendBasecampEmailVerificationMutation, ResendBasecampEmailVerificationMutationVariables>;
export const SelfCheckOutDocument = gql`
    mutation SelfCheckOut($token: String!, $assignmentId: ID!, $missingItemIds: [Int!], $source: SelfCheckinLifecycleSource) {
  selfCheckOut(
    token: $token
    assignmentId: $assignmentId
    missingItemIds: $missingItemIds
    source: $source
  ) {
    message
    roomNumber
    checkedOutAt
  }
}
    `;
export type SelfCheckOutMutationFn = Apollo.MutationFunction<SelfCheckOutMutation, SelfCheckOutMutationVariables>;

/**
 * __useSelfCheckOutMutation__
 *
 * To run a mutation, you first call `useSelfCheckOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfCheckOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfCheckOutMutation, { data, loading, error }] = useSelfCheckOutMutation({
 *   variables: {
 *      token: // value for 'token'
 *      assignmentId: // value for 'assignmentId'
 *      missingItemIds: // value for 'missingItemIds'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useSelfCheckOutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelfCheckOutMutation, SelfCheckOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelfCheckOutMutation, SelfCheckOutMutationVariables>(SelfCheckOutDocument, options);
      }
export type SelfCheckOutMutationHookResult = ReturnType<typeof useSelfCheckOutMutation>;
export type SelfCheckOutMutationResult = Apollo.MutationResult<SelfCheckOutMutation>;
export type SelfCheckOutMutationOptions = Apollo.BaseMutationOptions<SelfCheckOutMutation, SelfCheckOutMutationVariables>;
export const GetSelfCheckOutChecklistDocument = gql`
    query GetSelfCheckOutChecklist($token: String!, $assignmentId: ID!) {
  selfCheckOutChecklist(token: $token, assignmentId: $assignmentId) {
    id
    label
    sortOrder
  }
}
    `;

/**
 * __useGetSelfCheckOutChecklistQuery__
 *
 * To run a query within a React component, call `useGetSelfCheckOutChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfCheckOutChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfCheckOutChecklistQuery({
 *   variables: {
 *      token: // value for 'token'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetSelfCheckOutChecklistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSelfCheckOutChecklistQuery, GetSelfCheckOutChecklistQueryVariables> & ({ variables: GetSelfCheckOutChecklistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSelfCheckOutChecklistQuery, GetSelfCheckOutChecklistQueryVariables>(GetSelfCheckOutChecklistDocument, options);
      }
export function useGetSelfCheckOutChecklistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSelfCheckOutChecklistQuery, GetSelfCheckOutChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSelfCheckOutChecklistQuery, GetSelfCheckOutChecklistQueryVariables>(GetSelfCheckOutChecklistDocument, options);
        }
export function useGetSelfCheckOutChecklistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSelfCheckOutChecklistQuery, GetSelfCheckOutChecklistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSelfCheckOutChecklistQuery, GetSelfCheckOutChecklistQueryVariables>(GetSelfCheckOutChecklistDocument, options);
        }
export type GetSelfCheckOutChecklistQueryHookResult = ReturnType<typeof useGetSelfCheckOutChecklistQuery>;
export type GetSelfCheckOutChecklistLazyQueryHookResult = ReturnType<typeof useGetSelfCheckOutChecklistLazyQuery>;
export type GetSelfCheckOutChecklistSuspenseQueryHookResult = ReturnType<typeof useGetSelfCheckOutChecklistSuspenseQuery>;
export type GetSelfCheckOutChecklistQueryResult = Apollo.QueryResult<GetSelfCheckOutChecklistQuery, GetSelfCheckOutChecklistQueryVariables>;
export const SelfCheckinDocument = gql`
    mutation SelfCheckin($input: SelfCheckinInput!) {
  selfCheckin(input: $input) {
    token
    guestFirstName
    guestLastName
    roomNumber
    buildingName
    buildingAccessCode
    roomAccessCode
    checkInDate
    checkOutDate
  }
}
    `;
export type SelfCheckinMutationFn = Apollo.MutationFunction<SelfCheckinMutation, SelfCheckinMutationVariables>;

/**
 * __useSelfCheckinMutation__
 *
 * To run a mutation, you first call `useSelfCheckinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfCheckinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfCheckinMutation, { data, loading, error }] = useSelfCheckinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfCheckinMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelfCheckinMutation, SelfCheckinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelfCheckinMutation, SelfCheckinMutationVariables>(SelfCheckinDocument, options);
      }
export type SelfCheckinMutationHookResult = ReturnType<typeof useSelfCheckinMutation>;
export type SelfCheckinMutationResult = Apollo.MutationResult<SelfCheckinMutation>;
export type SelfCheckinMutationOptions = Apollo.BaseMutationOptions<SelfCheckinMutation, SelfCheckinMutationVariables>;
export const GetSelfCheckinLookupDocument = gql`
    query GetSelfCheckinLookup($identity: SelfCheckinIdentityInput!) {
  selfCheckinLookup(identity: $identity) {
    reservations {
      assignmentId
      basecampId
      basecampName
      guestFirstName
      guestLastName
      checkInDate
      checkOutDate
      checkedInAt
      smsReminderStatus
      guestPhone
      hasEmail
      hasVehicle
    }
  }
}
    `;

/**
 * __useGetSelfCheckinLookupQuery__
 *
 * To run a query within a React component, call `useGetSelfCheckinLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfCheckinLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfCheckinLookupQuery({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useGetSelfCheckinLookupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSelfCheckinLookupQuery, GetSelfCheckinLookupQueryVariables> & ({ variables: GetSelfCheckinLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSelfCheckinLookupQuery, GetSelfCheckinLookupQueryVariables>(GetSelfCheckinLookupDocument, options);
      }
export function useGetSelfCheckinLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSelfCheckinLookupQuery, GetSelfCheckinLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSelfCheckinLookupQuery, GetSelfCheckinLookupQueryVariables>(GetSelfCheckinLookupDocument, options);
        }
export function useGetSelfCheckinLookupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSelfCheckinLookupQuery, GetSelfCheckinLookupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSelfCheckinLookupQuery, GetSelfCheckinLookupQueryVariables>(GetSelfCheckinLookupDocument, options);
        }
export type GetSelfCheckinLookupQueryHookResult = ReturnType<typeof useGetSelfCheckinLookupQuery>;
export type GetSelfCheckinLookupLazyQueryHookResult = ReturnType<typeof useGetSelfCheckinLookupLazyQuery>;
export type GetSelfCheckinLookupSuspenseQueryHookResult = ReturnType<typeof useGetSelfCheckinLookupSuspenseQuery>;
export type GetSelfCheckinLookupQueryResult = Apollo.QueryResult<GetSelfCheckinLookupQuery, GetSelfCheckinLookupQueryVariables>;
export const GetSelfCheckinReservationDocument = gql`
    query GetSelfCheckinReservation($token: String!, $assignmentId: ID!) {
  selfCheckinReservation(token: $token, assignmentId: $assignmentId) {
    token
    guestFirstName
    guestLastName
    roomNumber
    roomId
    buildingId
    buildingName
    buildingAccessCode
    roomAccessCode
    checkInDate
    checkOutDate
    checkedInAt
    checkedOutAt
    mapImageUrl
    welcomePamphletUrl
    welcomePamphletFilename
    guestEmail
    emailVerified
    buildings {
      id
      name
      positionX
      positionY
      gender
    }
    facilityCodes {
      id
      label
      code
    }
  }
}
    `;

/**
 * __useGetSelfCheckinReservationQuery__
 *
 * To run a query within a React component, call `useGetSelfCheckinReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfCheckinReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfCheckinReservationQuery({
 *   variables: {
 *      token: // value for 'token'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetSelfCheckinReservationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSelfCheckinReservationQuery, GetSelfCheckinReservationQueryVariables> & ({ variables: GetSelfCheckinReservationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSelfCheckinReservationQuery, GetSelfCheckinReservationQueryVariables>(GetSelfCheckinReservationDocument, options);
      }
export function useGetSelfCheckinReservationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSelfCheckinReservationQuery, GetSelfCheckinReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSelfCheckinReservationQuery, GetSelfCheckinReservationQueryVariables>(GetSelfCheckinReservationDocument, options);
        }
export function useGetSelfCheckinReservationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSelfCheckinReservationQuery, GetSelfCheckinReservationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSelfCheckinReservationQuery, GetSelfCheckinReservationQueryVariables>(GetSelfCheckinReservationDocument, options);
        }
export type GetSelfCheckinReservationQueryHookResult = ReturnType<typeof useGetSelfCheckinReservationQuery>;
export type GetSelfCheckinReservationLazyQueryHookResult = ReturnType<typeof useGetSelfCheckinReservationLazyQuery>;
export type GetSelfCheckinReservationSuspenseQueryHookResult = ReturnType<typeof useGetSelfCheckinReservationSuspenseQuery>;
export type GetSelfCheckinReservationQueryResult = Apollo.QueryResult<GetSelfCheckinReservationQuery, GetSelfCheckinReservationQueryVariables>;
export const GetSelfCheckinSessionDocument = gql`
    query GetSelfCheckinSession($token: String!) {
  selfCheckinSession(token: $token) {
    reservations {
      assignmentId
      basecampId
      basecampName
      guestFirstName
      guestLastName
      checkInDate
      checkOutDate
      checkedInAt
      guestPhone
      hasEmail
      hasVehicle
    }
  }
}
    `;

/**
 * __useGetSelfCheckinSessionQuery__
 *
 * To run a query within a React component, call `useGetSelfCheckinSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfCheckinSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfCheckinSessionQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetSelfCheckinSessionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSelfCheckinSessionQuery, GetSelfCheckinSessionQueryVariables> & ({ variables: GetSelfCheckinSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSelfCheckinSessionQuery, GetSelfCheckinSessionQueryVariables>(GetSelfCheckinSessionDocument, options);
      }
export function useGetSelfCheckinSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSelfCheckinSessionQuery, GetSelfCheckinSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSelfCheckinSessionQuery, GetSelfCheckinSessionQueryVariables>(GetSelfCheckinSessionDocument, options);
        }
export function useGetSelfCheckinSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSelfCheckinSessionQuery, GetSelfCheckinSessionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSelfCheckinSessionQuery, GetSelfCheckinSessionQueryVariables>(GetSelfCheckinSessionDocument, options);
        }
export type GetSelfCheckinSessionQueryHookResult = ReturnType<typeof useGetSelfCheckinSessionQuery>;
export type GetSelfCheckinSessionLazyQueryHookResult = ReturnType<typeof useGetSelfCheckinSessionLazyQuery>;
export type GetSelfCheckinSessionSuspenseQueryHookResult = ReturnType<typeof useGetSelfCheckinSessionSuspenseQuery>;
export type GetSelfCheckinSessionQueryResult = Apollo.QueryResult<GetSelfCheckinSessionQuery, GetSelfCheckinSessionQueryVariables>;
export const UpdateBasecampEmailDocument = gql`
    mutation UpdateBasecampEmail($token: String!, $email: String!) {
  updateBasecampEmail(token: $token, email: $email)
}
    `;
export type UpdateBasecampEmailMutationFn = Apollo.MutationFunction<UpdateBasecampEmailMutation, UpdateBasecampEmailMutationVariables>;

/**
 * __useUpdateBasecampEmailMutation__
 *
 * To run a mutation, you first call `useUpdateBasecampEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasecampEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasecampEmailMutation, { data, loading, error }] = useUpdateBasecampEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateBasecampEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBasecampEmailMutation, UpdateBasecampEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBasecampEmailMutation, UpdateBasecampEmailMutationVariables>(UpdateBasecampEmailDocument, options);
      }
export type UpdateBasecampEmailMutationHookResult = ReturnType<typeof useUpdateBasecampEmailMutation>;
export type UpdateBasecampEmailMutationResult = Apollo.MutationResult<UpdateBasecampEmailMutation>;
export type UpdateBasecampEmailMutationOptions = Apollo.BaseMutationOptions<UpdateBasecampEmailMutation, UpdateBasecampEmailMutationVariables>;
export const VerifyBasecampEmailDocument = gql`
    mutation VerifyBasecampEmail($verificationToken: String!) {
  verifyBasecampEmail(verificationToken: $verificationToken) {
    status
    guestFirstName
  }
}
    `;
export type VerifyBasecampEmailMutationFn = Apollo.MutationFunction<VerifyBasecampEmailMutation, VerifyBasecampEmailMutationVariables>;

/**
 * __useVerifyBasecampEmailMutation__
 *
 * To run a mutation, you first call `useVerifyBasecampEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyBasecampEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyBasecampEmailMutation, { data, loading, error }] = useVerifyBasecampEmailMutation({
 *   variables: {
 *      verificationToken: // value for 'verificationToken'
 *   },
 * });
 */
export function useVerifyBasecampEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyBasecampEmailMutation, VerifyBasecampEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyBasecampEmailMutation, VerifyBasecampEmailMutationVariables>(VerifyBasecampEmailDocument, options);
      }
export type VerifyBasecampEmailMutationHookResult = ReturnType<typeof useVerifyBasecampEmailMutation>;
export type VerifyBasecampEmailMutationResult = Apollo.MutationResult<VerifyBasecampEmailMutation>;
export type VerifyBasecampEmailMutationOptions = Apollo.BaseMutationOptions<VerifyBasecampEmailMutation, VerifyBasecampEmailMutationVariables>;
export const CheckoutReminderOptionsDocument = gql`
    query CheckoutReminderOptions {
  checkoutReminderOptions {
    enabled
    smsAvailable
    emailAvailable
    disclosureVersion
    disclosure
    privacyUrl
    termsUrl
  }
}
    `;

/**
 * __useCheckoutReminderOptionsQuery__
 *
 * To run a query within a React component, call `useCheckoutReminderOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutReminderOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutReminderOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutReminderOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckoutReminderOptionsQuery, CheckoutReminderOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutReminderOptionsQuery, CheckoutReminderOptionsQueryVariables>(CheckoutReminderOptionsDocument, options);
      }
export function useCheckoutReminderOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutReminderOptionsQuery, CheckoutReminderOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutReminderOptionsQuery, CheckoutReminderOptionsQueryVariables>(CheckoutReminderOptionsDocument, options);
        }
export function useCheckoutReminderOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutReminderOptionsQuery, CheckoutReminderOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutReminderOptionsQuery, CheckoutReminderOptionsQueryVariables>(CheckoutReminderOptionsDocument, options);
        }
export type CheckoutReminderOptionsQueryHookResult = ReturnType<typeof useCheckoutReminderOptionsQuery>;
export type CheckoutReminderOptionsLazyQueryHookResult = ReturnType<typeof useCheckoutReminderOptionsLazyQuery>;
export type CheckoutReminderOptionsSuspenseQueryHookResult = ReturnType<typeof useCheckoutReminderOptionsSuspenseQuery>;
export type CheckoutReminderOptionsQueryResult = Apollo.QueryResult<CheckoutReminderOptionsQuery, CheckoutReminderOptionsQueryVariables>;
export const CheckoutReminderPreferencesDocument = gql`
    query CheckoutReminderPreferences($token: String!, $assignmentId: ID!) {
  checkoutReminderPreferences(token: $token, assignmentId: $assignmentId) {
    guestId
    phone
    promptDismissed
    smsEnabled
    smsConsentScope
    emailEnabled
    smsBlockedReason
    emailBlockedReason
  }
}
    `;

/**
 * __useCheckoutReminderPreferencesQuery__
 *
 * To run a query within a React component, call `useCheckoutReminderPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutReminderPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutReminderPreferencesQuery({
 *   variables: {
 *      token: // value for 'token'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useCheckoutReminderPreferencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutReminderPreferencesQuery, CheckoutReminderPreferencesQueryVariables> & ({ variables: CheckoutReminderPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutReminderPreferencesQuery, CheckoutReminderPreferencesQueryVariables>(CheckoutReminderPreferencesDocument, options);
      }
export function useCheckoutReminderPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutReminderPreferencesQuery, CheckoutReminderPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutReminderPreferencesQuery, CheckoutReminderPreferencesQueryVariables>(CheckoutReminderPreferencesDocument, options);
        }
export function useCheckoutReminderPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutReminderPreferencesQuery, CheckoutReminderPreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutReminderPreferencesQuery, CheckoutReminderPreferencesQueryVariables>(CheckoutReminderPreferencesDocument, options);
        }
export type CheckoutReminderPreferencesQueryHookResult = ReturnType<typeof useCheckoutReminderPreferencesQuery>;
export type CheckoutReminderPreferencesLazyQueryHookResult = ReturnType<typeof useCheckoutReminderPreferencesLazyQuery>;
export type CheckoutReminderPreferencesSuspenseQueryHookResult = ReturnType<typeof useCheckoutReminderPreferencesSuspenseQuery>;
export type CheckoutReminderPreferencesQueryResult = Apollo.QueryResult<CheckoutReminderPreferencesQuery, CheckoutReminderPreferencesQueryVariables>;
export const UpdateCheckoutReminderPreferencesDocument = gql`
    mutation UpdateCheckoutReminderPreferences($input: CheckoutReminderPreferenceInput!) {
  updateCheckoutReminderPreferences(input: $input) {
    guestId
    phone
    promptDismissed
    smsEnabled
    smsConsentScope
    emailEnabled
    smsBlockedReason
    emailBlockedReason
  }
}
    `;
export type UpdateCheckoutReminderPreferencesMutationFn = Apollo.MutationFunction<UpdateCheckoutReminderPreferencesMutation, UpdateCheckoutReminderPreferencesMutationVariables>;

/**
 * __useUpdateCheckoutReminderPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutReminderPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutReminderPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutReminderPreferencesMutation, { data, loading, error }] = useUpdateCheckoutReminderPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckoutReminderPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCheckoutReminderPreferencesMutation, UpdateCheckoutReminderPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCheckoutReminderPreferencesMutation, UpdateCheckoutReminderPreferencesMutationVariables>(UpdateCheckoutReminderPreferencesDocument, options);
      }
export type UpdateCheckoutReminderPreferencesMutationHookResult = ReturnType<typeof useUpdateCheckoutReminderPreferencesMutation>;
export type UpdateCheckoutReminderPreferencesMutationResult = Apollo.MutationResult<UpdateCheckoutReminderPreferencesMutation>;
export type UpdateCheckoutReminderPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutReminderPreferencesMutation, UpdateCheckoutReminderPreferencesMutationVariables>;